import { render } from "./GroupByDate.vue?vue&type=template&id=6c2aa480&scoped=true&ts=true"
import script from "./GroupByDate.vue?vue&type=script&lang=ts"
export * from "./GroupByDate.vue?vue&type=script&lang=ts"

import "./GroupByDate.vue?vue&type=style&index=0&id=6c2aa480&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2aa480"]])

export default __exports__